import { HazardMapType } from "common/functions/classes/HazardMapType";
import { DrawingId } from "common/types/DrawingId";
import { useCallback, useContext, useEffect, useState } from "react";
import { SearchMapContext } from "../../context";

const id: DrawingId = "takashio";

export const useHooks = (on: boolean) => {
  const { map } = useContext(SearchMapContext);
  const [takashioMapType, setTakashioMapType] = useState<
    HazardMapType | undefined
  >(undefined);

  // マップタイプ構築
  const constructTakashioMapType = useCallback(() => {
    if (map) {
      const mapType = new HazardMapType(
        `${id}MapType`,
        map,
        [
          "https://disaportaldata.gsi.go.jp/raster/03_hightide_l2_shinsuishin_data/{z}/{x}/{y}.png"
        ],
        17,
        0.8,
        true
      );

      setTakashioMapType(mapType);
    }
  }, [map]);

  // 描画
  const drawTakashio = useCallback(async () => {
    if (map && takashioMapType) {
      for (let i = 0; i < map.overlayMapTypes.getLength(); i++) {
        const mapType = map.overlayMapTypes.getAt(
          i
        ) as unknown as HazardMapType;

        if (mapType.id === `${id}MapType`) {
          map.overlayMapTypes.removeAt(i);
          break;
        }
      }

      if (on) {
        map.overlayMapTypes.insertAt(
          0,
          takashioMapType as unknown as google.maps.MapType
        );
      }
    }
  }, [takashioMapType, map, on]);

  useEffect(() => {
    setTimeout(() => constructTakashioMapType(), 0);
  }, [constructTakashioMapType]);

  useEffect(() => {
    drawTakashio();
  }, [drawTakashio]);

  return { map } as const;
};
